import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import Button from './ui/Button';
import Icon from './AppIcon';

const RealtimeTest = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [testResults, setTestResults] = useState([]);

  const addTestResult = (message) => {
    setTestResults(prev => [...prev, {
      id: Date.now(),
      message,
      timestamp: new Date()?.toLocaleTimeString()
    }]);
  };

  const testBookingStatusUpdate = async () => {
    try {
      addTestResult('Testing booking status update...');
      
      // Get a random booking to update
      const { data: bookings, error: fetchError } = await supabase?.from('bookings')?.select('id, booking_status')?.limit(1);
      
      if (fetchError) {
        addTestResult(`Error fetching booking: ${fetchError?.message}`);
        return;
      }
      
      if (!bookings || bookings?.length === 0) {
        addTestResult('No bookings found to test with');
        return;
      }
      
      const booking = bookings?.[0];
      const newStatus = booking?.booking_status === 'confirmed' ? 'pending' : 'confirmed';
      
      const { error: updateError } = await supabase?.from('bookings')?.update({ 
          booking_status: newStatus,
          updated_at: new Date()?.toISOString()
        })?.eq('id', booking?.id);
      
      if (updateError) {
        addTestResult(`Error updating booking: ${updateError?.message}`);
      } else {
        addTestResult(`✅ Successfully updated booking ${booking?.id} to ${newStatus}`);
      }
    } catch (error) {
      addTestResult(`❌ Test failed: ${error?.message}`);
    }
  };

  const clearResults = () => {
    setTestResults([]);
  };

  if (!isVisible) {
    return (
      <div className="fixed bottom-4 right-4 z-50">
        <Button
          onClick={() => setIsVisible(true)}
          className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg"
        >
          <Icon name="Zap" size={16} className="mr-2" />
          Test Real-time
        </Button>
      </div>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-4 w-80 max-h-96 overflow-hidden">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-gray-900">Real-time Test</h3>
        <div className="flex gap-2">
          <Button
            onClick={testBookingStatusUpdate}
            size="sm"
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            <Icon name="Play" size={14} className="mr-1" />
            Test
          </Button>
          <Button
            onClick={clearResults}
            size="sm"
            variant="outline"
          >
            <Icon name="X" size={14} />
          </Button>
          <Button
            onClick={() => setIsVisible(false)}
            size="sm"
            variant="outline"
          >
            <Icon name="Minus" size={14} />
          </Button>
        </div>
      </div>
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {testResults?.length === 0 ? (
          <p className="text-sm text-gray-500">Click "Test" to update a booking status and see real-time updates in My Tickets page.</p>
        ) : (
          testResults?.map((result) => (
            <div key={result?.id} className="text-xs bg-gray-50 p-2 rounded">
              <div className="text-gray-500">{result?.timestamp}</div>
              <div className="text-gray-900">{result?.message}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RealtimeTest;
